import * as React from "react";
import "./App.css";
import FormAcquirer from "./components/form";
import FormGetTrx from "./components/getTrxForm";
import "bootstrap/dist/css/bootstrap.min.css";
import ResponsiveAppBar from "./components/header";

function App() {
  const [sharedValue, setSharedValue] = React.useState("");

  const handleAcquirerSubmit = (trxId) => {
    setSharedValue(trxId);
  };

  return (
    <>
      <div className="App">
        <ResponsiveAppBar />
        <FormAcquirer onSubmitData={handleAcquirerSubmit} />
      </div>

      <div className="App">
        <FormGetTrx sharedValue={sharedValue} />
      </div>
    </>
  );
}

export default App;
